import { useAppSelector } from "src/store/hooks";

export type SlotProgress = {
    isSlotComplete: boolean;
    completedPages: number;
    totalPages: number;
};

type Properties = {
    achievements: SlotProgress[];
};

const ModuleProgressBar = (props: Properties) => {
    const config = useAppSelector(state => state.globalState.config);
    const { achievements } = props;
    const themeColor = config?.themeColor || '#acbcbc';

    const segments = achievements.map((slot, slotIndex) => {
        // Create page subdivisions within each slot
        const pageSubdivisions = Array.from({ length: slot.totalPages }, (_, pageIndex) => {
            const isPageComplete = pageIndex < slot.completedPages;
            let pageClassName = 'page-subdivision';
            if (isPageComplete) {
                pageClassName += ' page-filled';
            }
            
            return (
                <div 
                    className={pageClassName} 
                    key={`${slotIndex}-${pageIndex}`}
                    style={{ 
                        backgroundColor: isPageComplete ? themeColor : ''
                    }} 
                />
            );
        });

        let slotClassName = 'slot-item';
        if (slot.isSlotComplete) {
            slotClassName += ' slot-filled';
        }
        
        return (
            <div 
                className={slotClassName} 
                key={slotIndex}
                style={{
                    borderColor: slot.isSlotComplete ? themeColor : ''
                }}
            >
                <div className="page-subdivisions-container">
                    {pageSubdivisions}
                </div>
            </div>
        );
    });

    return (
        <div className="progress-segment">
            {segments}
        </div>
    );
};

export default ModuleProgressBar;
